import {CHANGE_POPUP_TRAILER,} from '@/store/mutation-types';


const state = {
    popupTrailer: {
        show: false,
        url: '',
        provider: '',
        title: ''
    },
};

const getters = {
    popupTrailer: state => state.popupTrailer,
};

const mutations = {
    [CHANGE_POPUP_TRAILER](state, params) {
        state.popupTrailer = params
    },
};

export default {
    state,
    getters,
    mutations,
};
